import React from 'react';
import { Link } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  Collapse,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Button,
} from 'reactstrap';

/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/
import logoicon from '../../assets/images/logo-light-icon.png';
import logolighticon from '../../assets/images/logo-light-icon.png';
import logodarktext from '../../assets/images/logo-text.png';
import logolighttext from '../../assets/images/logo-light-text.png';
import userIcon from '../../assets/images/icon/user.png';

import loginAPI from '../../api/authentication/login.js';

import './header.scss';

// Set at build time for deployments staff need to tell apart (e.g. "Partner
// Prod"); unset everywhere else, so our own app shows no badge.
const ENV_LABEL = process.env.REACT_APP_ENV_LABEL;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.showMobilemenu = this.showMobilemenu.bind(this);
    this.sidebarHandler = this.sidebarHandler.bind(this);
    this.state = {
      isOpen: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  /*--------------------------------------------------------------------------------*/
  /*To open Search Bar                                                              */
  /*--------------------------------------------------------------------------------*/
  toggleMenu() {
    document.getElementById('search').classList.toggle('show-search');
  }
  /*--------------------------------------------------------------------------------*/
  /*To open NAVBAR in MOBILE VIEW                                                   */
  /*--------------------------------------------------------------------------------*/
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  /*--------------------------------------------------------------------------------*/
  /*To open SIDEBAR-MENU in MOBILE VIEW                                             */
  /*--------------------------------------------------------------------------------*/
  showMobilemenu() {
    document.getElementById('main-wrapper').classList.toggle('show-sidebar');
  }
  sidebarHandler = () => {
    let element = document.getElementById('main-wrapper');
    switch (this.props.data.settings[0].sidebartype) {
      case 'full':
      case 'iconbar':
        element.classList.toggle('mini-sidebar');
        if (element.classList.contains('mini-sidebar')) {
          element.setAttribute('data-sidebartype', 'mini-sidebar');
        } else {
          element.setAttribute(
            'data-sidebartype',
            this.props.data.settings[0].sidebartype
          );
        }
        break;

      case 'overlay':
      case 'mini-sidebar':
        element.classList.toggle('full');
        if (element.classList.contains('full')) {
          element.setAttribute('data-sidebartype', 'full');
        } else {
          element.setAttribute(
            'data-sidebartype',
            this.props.data.settings[0].sidebartype
          );
        }
        break;

      default:
    }
  };

  selectedHeaderCSS = (path) => {
    const { pathname } = this.props.location;
    return `custom-nav-link nav-link ${pathname === path && 'active-nav-link'}`;
  };

  handleLogout = () => {
    loginAPI.logout();
  };

  render() {
    const { profileData } = this.props;
    const { email } = profileData;

    return (
      <header
        className="topbar navbarbg primary-background-color"
        data-navbarbg={this.props.data.settings[0].navbarbg}
      >
        <Navbar className={'top-navbar ' + 'navbar-dark'} expand="md">
          <div
            className="navbar-header"
            id="logobg"
            data-logobg={this.props.data.settings[0].logobg}
          >
            {/*--------------------------------------------------------------------------------*/}
            {/* Mobile View Toggler  [visible only after 768px screen]                         */}
            {/*--------------------------------------------------------------------------------*/}
            <a
              className="nav-toggler d-block d-md-none text-white"
              onClick={this.showMobilemenu}
            >
              {/*<i className="ti-menu ti-close" />*/}
            </a>
            {/*--------------------------------------------------------------------------------*/}
            {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
            {/*--------------------------------------------------------------------------------*/}
            <NavbarBrand href="/admin" className="d-flex align-items-center">
              <span className="brand-logo-equ-text">equ</span>
              {ENV_LABEL && (
                <span className="badge badge-warning ml-2">{ENV_LABEL}</span>
              )}
            </NavbarBrand>
            <a
              href="#"
              className="d-none d-md-flex align-items-center text-white ml-3 nav-link px-2"
              onClick={(e) => {
                e.preventDefault();
                this.sidebarHandler();
              }}
              style={{ cursor: 'pointer' }}
            >
              <i className="ti-menu icon-color" />
            </a>
            {/*--------------------------------------------------------------------------------*/}
            {/* Mobile View Toggler  [visible only after 768px screen]                         */}
            {/*--------------------------------------------------------------------------------*/}
            <a
              className="topbartoggler d-block d-md-none text-white"
              onClick={this.toggle}
            >
              <i className="ti-menu" />
            </a>
          </div>
          <Collapse
            className="navbarbg"
            isOpen={this.state.isOpen}
            navbar
            data-navbarbg={this.props.data.settings[0].navbarbg}
          >
            <Nav className="ml-auto float-right" navbar>
              {/*--------------------------------------------------------------------------------*/}
              {/* Start Profile Dropdown                                                         */}
              {/*--------------------------------------------------------------------------------*/}
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="pro-pic">
                  <img
                    src={userIcon}
                    alt="user"
                    className="rounded-circle icon-background-color"
                    width="31"
                  />
                </DropdownToggle>
                <DropdownMenu right className="user-dd">
                  <div className="d-flex no-block align-items-center p-3 mb-2 border-bottom">
                    {/* <div className="">
                      <img
                        src="https://via.placeholder.com/150"
                        alt="user"
                        className="rounded"
                        width="80"
                      />
                    </div> */}
                    <div className="ml-3">
                      <p className="text-muted mb-0">{email}</p>
                      <Button
                        color="danger"
                        className="btn-rounded mt-2"
                        onClick={() => {
                          this.props.history.push('/admin/account');
                        }}
                      >
                        View Profile
                      </Button>
                    </div>
                  </div>
                  <DropdownItem onClick={this.handleLogout}>
                    <i className="fa fa-power-off mr-1 ml-1" /> Logout
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              {/*--------------------------------------------------------------------------------*/}
              {/* End Profile Dropdown                                                           */}
              {/*--------------------------------------------------------------------------------*/}
            </Nav>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
export default Header;
